import AISummaryResolver from "resolvers/RTMResolvers/AISummaryResolver";

/**
 * Subscribe to Ai Summary service
 */
export default (() => {
  /**
   * @type {AISummaryResolver}
   */
  let aisummaryResolver;
  let isRegistered = false;
  
  const _subscriptions = {};
  const _rtmUnsubscribeFunctions = {};

  /**
   * Initiate ambrosia text extraction
   * @param {string} ambrosiaUrl
   */

  const generateContent = async ({ambrosiaUrl, model, max_tokens, contents, taskId, correlationId, action, activityId, accountId, metadata}) => await aisummaryResolver.generateContent({ambrosiaUrl, model, max_tokens, contents, taskId, correlationId, action, activityId, accountId, metadata});

  const AISummarySubscribe = async (correlationId, listener) => {
    _rtmUnsubscribeFunctions[correlationId] =
      await aisummaryResolver.summarySubscribe(correlationId, listener);

    _subscriptions[correlationId] = _subscriptions[correlationId] || [];
    _subscriptions[correlationId].push(
      
      listener);

    return () => {
      const listenerIndex = _subscriptions[correlationId].indexOf(listener);
      _subscriptions[correlationId].splice(listenerIndex, 1);
      if (_subscriptions[correlationId].length === 0) {
        _forgetAISummaryJob(correlationId);
      }
    };
  };

  const AISummaryUnSubscribe = (correlationId) => {
    if (_subscriptions[correlationId]) {
      _subscriptions[correlationId] = null;
    }
    _forgetAISummaryJob(correlationId);
  };

  function _forgetAISummaryJob(correlationId) {
    if (_rtmUnsubscribeFunctions[correlationId]) {
      _rtmUnsubscribeFunctions[correlationId]();
      _rtmUnsubscribeFunctions[correlationId] = null;
    }
  }

  return {
    isRegistered: () => isRegistered,
    register: (connectionProvider) => {
      isRegistered = true;
      aisummaryResolver = new AISummaryResolver(connectionProvider);
    },
    generateContent,
    AISummarySubscribe,
    AISummaryUnSubscribe,
  };
})();
